/**
 * アプリケーションエラー例外
 */
export default class ApplicationError extends Error {
  constructor(description, ...args) {
    super(...args);

    Object.defineProperty(this, 'name', {
      configurable: true,
      enumerable: false,
      value: this.constructor.name,
      writable: true,
    });

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApplicationError);
    }

    // description 内の情報は画面表示用
    // code: エラーコード
    // その他付加情報: 開発に応じて
    // ※ローカライズが必要なので考慮する。
    this.description = description;
  }
}
